export default "__VITE_ASSET__C2UNNv41__"